import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { error } = theme.palette;

  return {
    container: {
      display: "flex",
      alignItems: "center",
      marginLeft: 0,
      "&.withIndention": {
        marginLeft: 8
      }
    },
    sectionValidIcon: {
      width: 17,
      height: 17,
      marginTop: 2
    },
    valid: {
      color: "#489B77"
    },
    invalid: {
      color: error.main
    },
    errorText: {
      display: "flex",
      alignItems: "center",
      color: error.main,
      marginLeft: 0,
      fontSize: 13,
      "&.withIndention": {
        marginLeft: 8
      }
    }
  };
});
